export const spectrim = {
    agencyCode: '970',
    name: 'Spectrim',
    shortName: 'Spectrim',
    slug: 'dir',
  };
  